const GlobalSnackbarStyles = ({ theme }: any) => ({

})

export default GlobalSnackbarStyles
